<template>
  <div>
    <b-overlay :show="showOverlay" rounded="sm">
    <view-customer
      ref="view-customer-ref"
      :isCustomerVisible="isCustomerVisible"
      @setNewCustomerForm="setNewCustomerForm"
      :id="orderModel.customer_id"
      :hide-buttons="false"
      @update-model="setCustomer"
    />

    <div class="row filter-form p-0">
      <div
        class="col-12 mt-3"
        :class="{
          'col-md-3': !!orderModel.order_type_id,
          'col-md-12': !orderModel.order_type_id,
          dd: !!isNew,
        }"
      >
        <label class="mb-3">
          <strong>{{ $translate("type") }}<span class="red">*</span></strong>
        </label>
        <b-form-input
          v-if="!isNew"
          id="input-type"
          :value="order_type_name"
          readonly
        ></b-form-input>
        <b-form-select
          class="form-control"
          v-else
          id="input-type"
          v-model="orderModel.order_type_id"
          :options="filteredOrderTypes | mapOptions"
        >
          <template #first>
            <b-form-select-option :value="null">{{
              $translate("select_activity_type")
            }}</b-form-select-option>
          </template>
        </b-form-select>
      </div>
      <b-col
        md="3"
        cols="12"
        class="mt-3"
        :class="{ dd: !!editMode }"
        v-show="!!orderModel.order_type_id"
      >
        <label class="mb-3">
          <strong>{{ $translate("interaction_type") }}</strong>
        </label>
        <b-form-input
          v-if="!editMode"
          id="input-interaction-type"
          :value="interaction_type_name"
          readonly
        ></b-form-input>
        <b-form-select
          v-else
          id="input-interaction-type"
          class="form-control"
          v-model="orderModel.interaction_type_id"
          :options="interactionTypes | mapOptions"
          :disabled="ordercompleted"
          required
        >
          <template #first>
            <b-form-select-option :value="null">{{
              $translate("select_interaction_type_if_applicable")
            }}</b-form-select-option>
          </template>
        </b-form-select>
      </b-col>
      <b-col md="3" cols="12" class="mt-3" v-show="!!orderModel.order_type_id">
        <label class="mb-3"
          ><strong>{{ $translate("reference_no") }}</strong></label
        >
        <b-form-input
          id="input-reference_no"
          v-model="orderModel.reference_no"
          :placeholder="$translate('activity_ref_no_placeholder')"
          :readonly="!isNew"
        ></b-form-input>
      </b-col>
      <b-col md="3" cols="12" class="mt-3" v-show="!!orderModel.order_type_id">
        <label class="mb-3"
          ><strong>{{ $translate("description") }}</strong></label
        >
        <textarea
          id="input-description"
          v-model="orderModel.description"
          class="form-control w-100"
          :placeholder="$translate('activity_description_placeholder')"
          rows="6"
          max-rows="10"
          :disabled="!editMode"
        ></textarea>
      </b-col>
      <b-col
        md="3"
        cols="12"
        class="mt-3"
        v-if="checkAdditionaField1"
        v-show="!!orderModel.order_type_id"
      >
        <label class="mb-3">
          <strong>{{ additional_field_1.label }}</strong>
        </label>
        <b-form-input
          id="input-additional-field-1"
          class="form-control"
          v-model="orderModel.additional_field_1"
          placeholder=""
          :readonly="!editMode"
        ></b-form-input>
      </b-col>
      <b-col
        md="3"
        cols="12"
        class="mt-3"
        :class="{ dd: !!editMode }"
        v-if="checkAdditionaField2"
        v-show="!!orderModel.order_type_id"
      >
        <label class="mb-3">
          <strong>{{ additional_field_2_label }}</strong>
        </label>
        <b-form-input
          v-if="!editMode"
          id="input-additonal-field-2"
          :value="additional_field_2_name"
          readonly
        ></b-form-input>
        <b-form-select
          v-else
          id="input-additonal-field-2"
          class="form-control"
          v-model="orderModel.additional_field_2"
          :options="additional_field_2 | mapOptions"
          :disabled="ordercompleted"
          required
        >
          <template #first>
            <b-form-select-option :value="null"
              >{{ $translate("select") }}
              {{ additional_field_2_label }}
            </b-form-select-option>
          </template>
        </b-form-select>
      </b-col>
      <b-col
        md="3"
        cols="12"
        class="mt-3"
        :class="{ dd: !!editMode }"
        v-show="!!orderModel.order_type_id"
      >
        <label class="mb-3">
          <strong> {{ $translate("category") }} </strong>
        </label>
        <b-form-input
          v-if="!editMode"
          id="input-category-5"
          class="form-control"
          :value="request_category_name"
          readonly
        ></b-form-input>
        <b-form-select
          class="form-control"
          v-else
          id="input-category-5"
          v-model="orderModel.request_category_id"
          :options="categories | mapOptions"
          :disabled="ordercompleted"
          required
        >
          <template #first>
            <b-form-select-option :value="null">{{
              $translate("select_category_placeholder")
            }}</b-form-select-option>
          </template>
        </b-form-select>
      </b-col>
      <b-col
        md="3"
        cols="12"
        class="mt-3"
        :class="{ dd: !!editMode }"
        v-show="!!orderModel.order_type_id"
      >
        <label class="mb-3"
          ><strong>{{ $translate("progress_status") }}</strong></label
        >
        <b-form-input
          v-if="!editMode"
          id="input-progress-status"
          :value="progress_status_name"
          readonly
        ></b-form-input>
        <b-form-select
          class="form-control"
          v-else
          id="input-progress-status"
          v-model="orderModel.progress_status_id"
          :options="progress_statuses | mapOptions"
          :disabled="ordercompleted"
          required
        >
          <template #first>
            <b-form-select-option :value="null"
              >{{ $translate("select_progress_status") }}
            </b-form-select-option>
          </template>
        </b-form-select>
      </b-col>
      <b-col
        md="3"
        cols="12"
        class="mt-3"
        :class="{ dd: !!editMode }"
        v-show="!!orderModel.order_type_id"
      >
        <label class="mb-3">
          <strong>{{ $translate("crm_opportunity_type") }}</strong>
        </label>
        <b-form-input
          class="mb-2"
          v-if="!editMode"
          id="input-crm_opportunity_type_id"
          :value="crm_opportunity_type_name"
          readonly
        ></b-form-input>
        <b-form-select
          class="form-control mb-2"
          v-else
          id="input-crm_opportunity_type_id"
          v-model="orderModel.crm_opportunity_type_id"
          :options="crm_opportunity_types | mapOptions"
          :disabled="!editMode"
          required
        >
          <template #first>
            <b-form-select-option :value="null"
              >{{ $translate("select_crm_opportunity_type") }}
            </b-form-select-option>
          </template>
        </b-form-select>

        <b-button v-if="crm_opportunity_type_name != ''" variant="info" size="sm" :disabled="!editMode"   @click="setOpportunityProductsOfInterestView" v-b-tooltip.hover.bottom="$translate('add_products_of_interest')">
          <i class="fa fa-heart"></i>
          
        </b-button>

        <b-button v-if="crm_opportunity_type_name != ''" class="mx-2" variant="info" size="sm"   @click="setOpportunityProductsOfInterestList(orderModel.reference_no)" v-b-tooltip.hover.bottom="$translate('view_products_of_interest')">          
        <i class="fa fa-eye"></i>
        </b-button>
      </b-col>
      <b-col
        md="3"
        cols="12"
        class="mt-3"
        :class="{ dd: !!editMode }"
        v-show="!!orderModel.order_type_id"
      >
        <label class="mb-3"
          ><strong>{{ $translate("crm_activity_health") }}</strong></label
        >
        <b-form-input
          v-if="!editMode"
          id="input-activity_health_id"
          :value="activity_health_name"
          readonly
        ></b-form-input>
        <b-form-select
          class="form-control"
          v-else
          id="input-activity_health_id"
          v-model="orderModel.activity_health_id"
          :options="activity_healths | mapOptions"
          :disabled="ordercompleted"
          required
        >
          <template #first>
            <b-form-select-option :value="null"
              >{{ $translate("select_activity_health") }}
            </b-form-select-option>
          </template>
        </b-form-select>
      </b-col>
      <b-col md="12" cols="12" class="mt-3" v-show="!!orderModel.order_type_id">
        <label class="mb-3"
          ><strong>{{ $translate("customer") }}</strong
          ><span class="red">*</span></label
        >
      </b-col>
      <!-- sm="11" -->
      <b-col
        cols="12"
        class="full-field"
        :class="{ 'd-flex flex-nowrap gap-2': isNew }"
        v-show="!!orderModel.order_type_id"
      >
        <template v-if="isPartnerType">
          <div :class="{ 'append-buttons': isNew }">
            <customer-type-ahead
              v-model="orderModel.customer_id"
              @set-customer="setCustomer"
              required
              :disabled="(editMode ? orderModel.released !== 0 :  (!isNew || isCustomerVisible) )  "
            ></customer-type-ahead>
          </div>
          <button v-if="isPartnerType && isNew" @click="setNewCustomerForm">
            <div>
              <b-button v-b-tooltip.hover title="Add" variant="blue-icon">
                <img src="@/assets/images/icon/gradient-add.svg" />
              </b-button>
            </div>
          </button>
        </template>
        <template v-else-if="!!orderModel.order_type_id">
          {{ company.name }}
        </template>
      </b-col>
      <b-col
        md="12"
        cols="12"
        class="mt-3"
        :class="{ dd: !!editMode }"
        v-if="isPartnerType"
        v-show="!!orderModel.order_type_id"
      >
        <label class="mb-3">
          <strong>{{ $translate("customer_agent") }}</strong>
        </label>
        <b-form-input
          v-if="!editMode"
          :value="customer_agent_name"
          id="input-customer-agents"
          readonly
        ></b-form-input>
        <b-form-select
          class="form-control"
          v-else
          id="input-cutomer-agent"
          v-model="orderModel.customer_agent_id"
          :options="cutomerAgents"
          value-field="id"
          text-field="agent_name"
          :disabled="ordercompleted"
          required
        >
          <template #first>
            <b-form-select-option :value="null"
              >{{ $translate("select_customer_agent") }}
            </b-form-select-option>
          </template>
        </b-form-select>
      </b-col>
      <b-col
        md="12"
        cols="12"
        class="mt-3"
        v-show="!!orderModel.order_type_id"
        v-if="!isCustomerVisible && isNew && isPartnerType"
      >
        <div class="form-control p-3">
          <b-form-row class="mb-3">
            <label class="mb-3">
              <strong
                >{{ $translate("delivery_location")
                }}<span class="red">*</span></strong
              >
            </label>
            <b-col md="12" cols="12">
              <portal-target name="deliveryLocationView"></portal-target>
            </b-col>
          </b-form-row>
        </div>
      </b-col>
      <b-col
        md="12"
        cols="12"
        class="mt-3"
        :class="{ dd: !!editMode }"
        v-if="
          (transaction_type && transaction_type.entity) !=
          (entities && entities.Internal)
        "
        v-show="!!orderModel.order_type_id"
      >
        <label class="mb-3"
          ><strong
            >{{ $translate("assigned_to") }}<span class="red"></span
          ></strong>
        </label>
        <b-form-input
          v-if="!editMode || ordercompleted"
          id="input-driver"
          :value="officer_name"
          readonly
        ></b-form-input>
        <b-form-select
          v-else
          id="input-driver"
          class="form-control"
          v-model="orderModel.driver_id"
          :options="officers | mapOptions"
          :disabled="
            (!allowToCreateOtherOfficers && isNew) ||
            (!allowToUpdateOtherOfficers && !isNew)
          "
        >
          <template #first>
            <b-form-select-option :value="null" disabled>{{
              $translate("select_officer")
            }}</b-form-select-option>
          </template>
        </b-form-select>
      </b-col>
      <b-col
        md="12"
        cols="12"
        class="mt-3"
        v-show="!!orderModel.order_type_id"
        v-if="!!orderModel.order_type_id && isNew"
      >
        <b-form-row v-if="!!orderModel.order_type_id && isNew">
          <b-col cols="2">
            <label class="mb-3"
              ><strong>{{ $translate("items") }}</strong></label
            >
          </b-col>
          <b-col md="12" cols="12" class="form-control p-3">
            <b-card>
              <portal-target name="OrderItemsView"> </portal-target>
            </b-card>
          </b-col>
        </b-form-row>
      </b-col>
      <b-col
        md="12"
        cols="12"
        class="mt-3"
        v-show="!!orderModel.order_type_id"
        v-if="!!orderModel.order_type_id && isNew"
      >
        <b-form-row v-if="!!orderModel.order_type_id && isNew">
          <b-col cols="2">
            <label class="font-weight-bold pt-0"
              ><strong>{{ $translate("messages") }}</strong></label
            >
          </b-col>
          <b-col
            md="12"
            cols="12"
            class="mt-4 form-control p-3"
            v-show="!!orderModel.order_type_id"
          >
            <b-card class="mt-2">
              <portal-target name="OrderMessagesView"> </portal-target>
            </b-card>
          </b-col>
        </b-form-row>
      </b-col>
      <b-col
        md="12"
        cols="12"
        class="mt-3"
        v-show="!!orderModel.order_type_id"
        v-if="!!orderModel.order_type_id && isNew"
      >
        <b-form-row v-if="!!orderModel.order_type_id && isNew">
          <b-col cols="2">
            <label class="font-weight-bold mb-3 pt-0"
              ><strong>{{ $translate("attachments") }}</strong></label
            >
          </b-col>
          <b-col
            md="12"
            cols="12"
            class="form-control p-3"
            v-show="!!orderModel.order_type_id"
          >
            <b-card>
              <portal-target name="OrderAttachmentsView"> </portal-target>
            </b-card>
          </b-col>
        </b-form-row>
      </b-col>
      <b-col md="6" cols="12" class="mt-3" v-show="!!orderModel.order_type_id">
        <label class="mb-3"
          ><strong
            >{{ $translate("due_date") }}<span class="red">*</span></strong
          ></label
        >
        <b-form-input
          id="input-date"
          v-model="orderModel.date"
          type="date"
          required
          :disabled="!editMode"
        ></b-form-input>
      </b-col>
      <b-col md="6" cols="12" class="mt-3" v-show="!!orderModel.order_type_id">
        <label class="mb-3"
          ><strong
            >{{ $translate("due_time") }}<span class="red">*</span></strong
          ></label
        >
        <b-form-input
          id="input-time"
          v-model="orderModel.time"
          type="time"
          required
          :disabled="!editMode"
        ></b-form-input>
      </b-col>
      <b-col md="12" cols="12" class="mt-3" v-show="showDocSection">
      
        <MasterDocument  :activity-type-id="orderModel.order_type_id"  />
      </b-col>
    </div>
    <ManageOpportunityProductsOfInterest  v-if="crm_opportunity_type_name != ''"
    ref="viewOpportunityProductsOfInterestItem" @item-added="evt => itemAdded(evt)"/>
    </b-overlay>
  </div>
</template>
<script>
import order_api from "@/api/order";
import moment from "moment";
import ViewCustomer from "@/views/Customers/ViewCustomer";
import { debounce } from "lodash";

import dateTimeMixins from "@/mixins/dateTimeMixins";
import popupMixins from "@/mixins/popupMixins";
import CustomerTypeAhead from "@/components/CustomerTypeAhead.vue";
import ManageOpportunityProductsOfInterest from "./ManageOpportunityProductsOfInterest.vue";

import permissionsMixins from "@/mixins/permissionsMixins";

import EventBus from "@/exports/event-bus.js";
import MasterDocument from './MasterDocument.vue';


const model_keys = Object.freeze([
  "id",
  "order_type_id",
  "customer_id",
  "customer_agent_id",
  "description",
  "driver_id",
  "reference_no",
  "request_category_id",
  "interaction_type_id",
  "progress_status_id",
  "additional_field_1",
  "additional_field_2",
  "order_template_id",
  "schedule_at",
  "additional_field",
  "signature",
  "linked_assets",
  "completed",
  "released",
  "rental_allowable",
  "delivery_location_section_id",
  "crm_opportunity_type_id",
  "activity_health_id",
]);

//const L = window.L
export default {
  name: "orders-viewSummary",
  components: {
    ViewCustomer,
    CustomerTypeAhead,
    ManageOpportunityProductsOfInterest,
    MasterDocument
  },
  data() {
    return {
      itemAddType: 0,
      isCustomerVisible: false,
      orderModel: {},
      category_id: null,
      driverModified: false,
      hasErrors: false,
      defaultDriver: null,
      primary_orders: [],
      primary_order_reference_no: null,
      valueWatchNotCompleted: true,
      isValueSet: false,
      showDocSection : false,
      showOverlay : false,
    };
  },
  mixins: [dateTimeMixins, popupMixins, permissionsMixins],
  props: ["viewMode"],
  filters: {
    capitalize: function (value) {
      if (!value) return "";
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    },
    mapOptions(arr) {
      if (!arr || !arr.length) return [];
      return arr
        .filter((x) => x)
        .map((x) => ({
          value: x.id,
          text: x.name,
        }));
    },
  },
  computed: {
    allowToCreateOtherOfficers() {
      return !!this.user_permissions.includes(
        "create.activity.assigned.to.others"
      );
    },
    allowToUpdateOtherOfficers() {
      return !!this.user_permissions.includes(
        "update.activity.assigned.to.others"
      );
    },
    additional_field_1() {
      return (
        this.$store.state.additionalField.additional_fields &&
        this.$store.state.additionalField.additional_fields.find(
          (x) => x.module_for == 1 && x.field_type === 1
        )
      );
    },
    additional_field_2() {
      const additionField =
        this.$store.state.additionalField.additional_fields &&
        this.$store.state.additionalField.additional_fields.find(
          (x) => x.module_for == 1 && x.field_type === 2
        );
      return additionField && additionField.fielditems;
    },
    additional_field_2_label() {
      const additionalField_2 =
        this.$store.state.additionalField.additional_fields &&
        this.$store.state.additionalField.additional_fields.find(
          (x) => x.module_for == 1 && x.field_type === 2
        );
      return additionalField_2 && additionalField_2.label;
    },
    isNew() {
      return !(this.order && this.order.id);
    },
    order() {
      return this.$store.state.orders.item;
    },
    allowTemplate() {
      return (
        !this.order.completed && (this.isNew || !this.order.order_template_id)
      );
    },
    entities() {
      return this.$store.getters["transactionType/entities"];
    },
    company() {
      return this.$store.state.company.settings;
    },
    transaction_type() {
      if (this.orderModel.order_type_id) {
        const _orderType =
          this.orderTypes.find((x) => x.id === this.orderModel.order_type_id) ||
          {};
        return _orderType.transaction_type;
      } else {
        return null;
      }
    },
    order_type_name() {
      const type = this.orderTypes.find(
        (x) => x.id === this.orderModel.order_type_id
      );
      return (type && type.name) || "";
    },
    crm_opportunity_types() {
      const crm_opportunity_types =
        this.$store.state.crmOpportunityTypes.crm_opportunity_types || []
      
        return crm_opportunity_types
    },

    activity_healths() {
      const health = (this.$store.state.health.items_not_paginated || []).map((x) => ({
          ...x,
          name: `${x.title} (${x.start}-${x.end})`,
        }))
      console.log('health', health)
      return health
    },

    agent_name() {
      if (this.isNew) {
        return (
          (this.orderModel &&
            this.orderModel.customer &&
            this.orderModel.customer.customer_agent &&
            this.orderModel.customer.customer_agent.agent_name) ||
          ""
        );
      } else {
        return (
          (this.order &&
            this.order.customer &&
            this.order.customer.customer_agent &&
            this.order.customer.customer_agent.agent_name) ||
          ""
        );
      }
    },
    customer_agent_name() {
      const customerAgents = this.cutomerAgents.find(
        (x) => x.id === this.orderModel.customer_agent_id
      );
      return (customerAgents && customerAgents.agent_name) || "";
    },
    additional_field_2_name() {
      const additionalField = this.additional_field_2.find(
        (x) => x.id === this.orderModel.additional_field_2
      );
      return (additionalField && additionalField.name) || "";
    },
    request_category_name() {
      const category = this.categories.find(
        (x) => x.id === this.orderModel.request_category_id
      );
      return (category && category.name) || "";
    },
    interaction_type_name() {
      const interactionType = this.interactionTypes.find(
        (x) => x.id === this.orderModel.interaction_type_id
      );
      return (interactionType && interactionType.name) || "";
    },
    progress_status_name() {
      const progressStatus = this.progress_statuses.find(
        (x) => x.id === this.orderModel.progress_status_id
      );
      console.log("progressStatus:", progressStatus);
      return (progressStatus && progressStatus.name) || "";
    },
    crm_opportunity_type_name() {
      const crm_opportunity_type = this.crm_opportunity_types.find(
        (x) => x.id === this.orderModel.crm_opportunity_type_id
      );
      console.log("crm_opportunity_type:", crm_opportunity_type);
      return (crm_opportunity_type && crm_opportunity_type.name) || "";
    },
    activity_health_name() {
      const crm_opportunity_type = this.activity_healths.find(
        (x) => x.id === this.orderModel.activity_health_id
      );
      console.log("crm_opportunity_type:", crm_opportunity_type);
      return (crm_opportunity_type && crm_opportunity_type.name) || "";
    },
    officer_name() {
      const officer = this.officers.find(
        (x) => x.id === this.orderModel.driver_id
      );
      console.log("officers", officer);
      return (officer && officer.name) || "";
    },

    editMode() {
      return this.isNew || !this.viewMode;
    },
    checkAdditionaField1() {
      return this.additional_field_1 && this.additional_field_1.label;
    },
    checkAdditionaField2() {
      return this.additional_field_2 && this.additional_field_2.length
        ? this.additional_field_2
        : "";
    },
    ordercompleted() {
      return this.orderModel.completed == 1 ? true : false;
    },

    signature_options() {
      return [
        {
          value: true,
          text: this.$translate("yes"),
        },
        {
          value: false,
          text: this.$translate("no"),
        },
      ];
    },
    user_permissions() {
      return this.$store.getters.user_permissions;
    },

    officers() {
      const _officers = this.$store.getters["users/sorted_officers"];
      console.log("_officers", _officers);
      return _officers;
    },
    interactionTypes() {
      return this.$store.state.interactionType.interaction_types;
    },
    cutomerAgents() {
      return this.$store.state.customerAgents.customer_agents;
    },
    entityOptions() {
      return this.$store.getters["transactionType/entityOptions"];
    },
    entityIdx() {
      return this.$store.state.transactionType.entityIdx;
    },
    orderTypes() {
      return this.$store.getters["orderType/activityTypesByPermission"].filter(
        (x) => x
      );
    },
    filteredOrderTypes() {
      const { entityIdx, orderTypes, getEntityIdx } = this;
      console.log("orderTypes:", orderTypes);
      if (
        entityIdx === getEntityIdx("Customer") ||
        entityIdx === getEntityIdx("Vendor")
      ) {
        return orderTypes.filter(
          (x) =>
            x.transaction_type.entity == entityIdx ||
            x.transaction_type.reference_entity == entityIdx
        );
      } else {
        return orderTypes.filter(
          (x) =>
            x.transaction_type.entity == entityIdx &&
            x.transaction_type.reference_entity != getEntityIdx("Customer") &&
            x.transaction_type.reference_entity != getEntityIdx("Vendor")
        );
      }
    },
    categories() {
      return this.$store.state.requestCategory.categories;
    },
    progress_statuses() {
      return this.$store.state.progressStatus.progress_statuses;
    },
    templates() {
      const templates = this.$store.state.orderTemplate.templates;
      return templates;
    },
    scheduleDate() {
      return this.$store.getters["orders/getScheduleDate"];
    },
    isPartnerType() {
      const { entity, reference_entity } = this.transaction_type || {};
      const { Vendor, Customer } = this.entities || {};
      return (
        entity == Customer || reference_entity == Customer || entity == Vendor
      );
    },
  },
  beforeDestroy() {
    this.$store.commit("orders/clearScheduleDate");
  },
  watch: {
    "orderModel.order_type_id": {
      handler: function (id) {
        this.show_required_docs(id,this.$route.params.id);
        if (this.$route.params.id == 0) {
          const orderType = this.orderTypes.find((x) => x.id == id);
          this.$nextTick(() => {
            if (!this.allowToCreateOtherOfficers) {
              this.$set(
                this.orderModel,
                "driver_id",
                this.$store.state.user.id
              );
            } else if (orderType && orderType.officer_id) {
              this.$set(
                this.orderModel,
                "driver_id",
                orderType && orderType.officer_id
              );
            } else {
              this.$set(
                this.orderModel,
                "driver_id",
                this.$store.state.user.id
              );
            }
            this.$set(
              this.orderModel,
              "interaction_type_id",
              orderType && orderType.interaction_type_id
            );
            EventBus.$emit(
              "set-rental-allowable",
              orderType && orderType.rental_allowable
            );
            EventBus.$emit(
              "set-template",
              orderType && orderType.activity_template_id
            );
          });

          
        
        }
      },
    },
    "orderModel.driver_id": function (id) {
      console.log("check driver update", id);
      console.log("Default Driver check", this.defaultDriver);
      if (
        this.defaultDriver &&
        id !== this.defaultDriver &&
        (this.allowToCreateOtherOfficers || this.allowToUpdateOtherOfficers)
      ) {
        this.driverModified = true;
        console.log("driver modified check");
      } else {
        console.log("driver is not modified check");
        this.driverModified = false;
      }
    },
    orderTypes: {
      immediate: true,
      handler: debounce(function (items) {
        this.setKeyDefault(items, "order_type_id");
      }, 1000),
      deep: true,
    },
    categories: {
      handler: function (items) {
        this.setKeyDefault(items, "request_category_id");
      },
      deep: true,
    },
    interactionTypes: {
      handler: function (items) {
        this.setKeyDefault(items, "interaction_type_id");
      },
      deep: true,
    },
    order: {
      handler: function () {
        this.$nextTick(() => this.setOrderForm());
      },
      deep: true,
    },
    driverModified: function (driverModified) {
      if (!this.allowToCreateOtherOfficers) {
        console.log(this.orderModel, "driverModified");
        EventBus.$emit("set-order-model", {
          order: this.orderModel,
          driverModified,
        });
      }
    },
    orderModel: {
      handler: function (order) {
        console.log("order.customer", order);
        EventBus.$emit("set-order-model", {
          order,
          driverModified: this.driverModified,
        });
        if (!order.id && !order.order_type_id) {
          const { categories, interactionTypes } = this;
          this.setKeyDefault(categories, "request_category_id");
          this.setKeyDefault(interactionTypes, "interaction_type_id");
        }
        if (this.$route.params.id == 0) {
          if (order.customer && order.customer.customer_agent_id) {
            this.$set(
              this.orderModel,
              "customer_agent_id",
              order.customer.customer_agent_id
            );
          }
        }
      },
      // deep: true,
    },
    itemAddType: function (val) {
      console.log("itemaddtype", val);
      if (val == 2) {
        this.$nextTick(() => {
          EventBus.$emit("trigger-add-item", val);
        });
      }
    },
    // isCustomerVisible: function () {
    //     this.setNewCustomerForm()
    // }
  },

  created() {
    EventBus.$on("update-assets", (linked_assets) => {
      this.$set(this.orderModel, "linked_assets", linked_assets);
    });
  },

  mounted() {
    this.$store.dispatch("additionalField/fetchAll", { module_for: 1 });
    this.setOrderForm();
  },
  methods: {
    getEntityIdx(text) {
      return (this.entityOptions.find((x) => x.text == text) || {}).value;
    },
    setKeyDefault(items, key) {
      if (items && items.length > 0) {
        const defaultType = items.filter((x) => x).find((x) => !!x.is_default);
        console.log("gettting", defaultType);
        if (
          defaultType &&
          !this.orderModel.key &&
          this.orderModel.key == defaultType.id
        ) {
          this.$set(this.orderModel, key, defaultType.id);
        }
      }
    },
    showOrderTemplateModal() {
      this.$bvModal.show("order-template-modal");
    },
    async validateOrderSummary() {
      let {
        orderModel: { customer, customer_id, order_type_id, date, time },
      } = this;

      // console.log('ssee',schedule_at,this.orderModel)

      if (!(await this.$validator.validate()))
        throw new Error(this.$translate("incomplete_submission"));
      if (!order_type_id) throw new Error(this.$translate("type_required"));
      if (!date) throw new Error(this.$translate("due_date_required"));
      if (!time) throw new Error(this.$translate("due_time_required"));

      if (this.isPartnerType) {
        const { name, location, location_section_id } = customer || {};
        if (!customer_id && !name)
          throw new Error(this.$translate("customer_name_required"));

        if (!location_section_id && location && !location.city)
          throw new Error(this.$translate("customer_location_required"));
      }
    },
    getModel() {
      return this.orderModel;
    },
    setOrderForm() {
      console.log("setOrderForm order", this.order);
      for (var key in this.orderModel) {
        if(key != 'rental_allowable') delete this.orderModel[key];
      }
      this.defaultDriver = this.order.driver_id;
      if (!this.allowToCreateOtherOfficers) {
        this.defaultDriver = this.$store.state.user.id;
      }
      for (const key of model_keys) {
        switch (key) {
          case "schedule_at": {
            // if (this.order.schedule_at) {
            const { date, time } = this.getLocalPartsFrLaravelDt(
              this.order.schedule_at
            );
            console.log("datetime", scheduledTime, moment().format("hh:mm"));
            const scheduledDate = moment().format("YYYY-MM-DD");
            const scheduledTime = moment().format("HH:mm");
            this.$set(this.orderModel, "date", date || scheduledDate);
            this.$set(this.orderModel, "time", time || scheduledTime);
            // }
            break;
          }
          case "linked_assets": {
            const val = this.order[key];
            let linked_assets = [];
            if (val) {
              linked_assets = JSON.parse(val);
            }
            this.$set(this.orderModel, key, linked_assets);
            break;
          }
          case "released":
          case "completed": {
            this.$set(this.orderModel, key, this.order[key] || 0);
            break;
          }
          default: {
            this.$set(this.orderModel, key, this.order[key] || null);
          }
        }
      }
      console.log("setOrderForm orderModel", this.orderModel);
    },

    async setNewCustomerForm() {
      const isChanged = (($this) => {
        const {
          orderModel: { customer_id, customer },
          isCustomerVisible,
          isNew,
        } = $this;
        const { code, name, email, phone, location_section_id } =
          customer || {};
        return (
          (isCustomerVisible &&
            !isNew &&
            !!(code || name || email || phone || location_section_id)) ||
          !!customer_id
        );
      })(this);
      console.log(isChanged, "isChanged");
      if (!isChanged || (await this.confirmCustomerToggle())) {
        this.$store.state.customers.item = null;
        this.isCustomerVisible = !this.isCustomerVisible;
        console.log("isChangedWorking?", this.isCustomerVisible);
        this.orderModel.customer_id = null;
      }
    },

    async confirmCustomerToggle() {
      return await this.$bvModal.msgBoxConfirm(
        this.$translate("erase_customer"),
        {
          headerClass: "p-0",
          footerClass: "d-flex justify-content-center border-0",
          contentClass: "custom-model-wrap",
          okTitle: this.$translate("ok"),
          cancelTitle: this.$cancelLabel(),
          okVariant: "info",
          cancelVariant: "info",
          title: this.$translate("confirmation"),
        }
      );
    },

    setCustomer(customer) {
      console.log('this.orderModel', this.orderModel)
      this.$set(this.orderModel, "customer", customer);
      this.$emit("set-location-section", customer?.location_section_id ?? null);
      this.$emit("set-customer-id", customer?.id || null);
    },
    async getLastCustomerOrder(customer_id) {
      const query = "";
      const page = 1;
      const filters = { customer_id };
      const result = await order_api.fetch(query, filters, page);
      let orders = result.data.success.data.data;
      console.log("first order", orders[0]);
      if (orders.length > 0) {
        this.orderModel.driver_id = orders[0].driver_id;
      }
    },

    setOpportunityProductsOfInterestView() {
      const { orderModel } = this

      
      let viewMode = this.viewMode;

      this.$refs['viewOpportunityProductsOfInterestItem'] &&
        this.$refs['viewOpportunityProductsOfInterestItem'].showItem(orderModel, {
          viewMode,
        })
    },

    setOpportunityProductsOfInterestList(reference_no) {
      const { orderModel } = this

      this.$refs['viewOpportunityProductsOfInterestItem'] &&
      this.$refs['viewOpportunityProductsOfInterestItem'].listItem(orderModel)
    },

    async show_required_docs(activity_type_id,order_id){
     console.log('activity_type_id',activity_type_id);
     if(activity_type_id != null){
      this.showOverlay = true;
      
      await this.$store.dispatch('acitivityTypeDocStore/fetchdocumentsAll', {  activityTypeId : activity_type_id,order_id :order_id});
      if (this.$store.state.acitivityTypeDocStore.docs && this.$store.state.acitivityTypeDocStore.docs.length > 0) {
          let modelData = this.$store.state.acitivityTypeDocStore.docs;
          this.showDocSection = true;
          this.orderModel = { ...this.orderModel, document: modelData };
      } else {
         
          this.showDocSection = false;
      }

      this.showOverlay = false;
     }
      
    }
  },
};
</script>
